<template>
  <div>
    <header
      class="cross-page-header"
      :style="{ backgroundImage: `url(${headerImg})` }"
    >
      <v-container class="d-flex justify-end align-end">
        <div class="text-center">
          <v-btn class="offer-box__button mr-15 mt-15" fab @click="routeToCategory">
            <v-row no-gutters class="flex-column justify-center align-center">
              <div>
                <i class="fas fa-3x white--text" :class="btnIcon"></i>
              </div>
              <div class="offer-box__button--text mt-1 mt-sm-5">
                {{ headerContent.btnTitle }}
              </div>
            </v-row>
          </v-btn>
        </div>
      </v-container>
    </header>
    <v-row
      no-gutters
      class="justify-center align-center cross-page-header-wrapper mt-5 flex-column"
    >
      <v-col cols="4" md="2">
        <img
          width="100%"
          height="100%"
          :src="companyLogo"
          :alt="$route.name"
          class="company-logo"
        />
      </v-col>
      <v-col cols="12" class="text-center header-info mt-5">
        <h1>{{ headerContent.title }}</h1>
        <p class="mt-5">{{ headerContent.slogan }}</p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    headerContent: {
      type: Object,
      require: true
    }
  },
  methods: {
    routeToCategory () {
      const currentPath = this.$route.path
      const newPath = currentPath.split('/')[2]
      this.$router.push(`/${newPath}`)
    }
  },
  computed: {
    headerImg () {
      const routePath = this.$route.path.split('/')[2]
      return require(`@/assets/category-banners/${routePath}.png`)
    },
    companyLogo () {
      const routePath = this.$route.path.split('/')[1]
      return require(`@/assets/cross-pages/${routePath}.png`)
    },
    btnIcon () {
      const categories = [
        { icon: 'fa-car-crash', name: 'Motor' },
        { icon: 'fa-car', name: 'Compulsory' },
        { icon: 'fa-heartbeat', name: 'Health' },
        { icon: 'fa-house-damage', name: 'Home' },
        { icon: 'fa-laptop-house', name: 'Dask' },
        { icon: 'fa-building', name: 'Company' },
        { icon: 'fa-user-injured', name: 'Personal' },
        { icon: 'fa-luggage-cart', name: 'Transportation' },
        { icon: 'fa-briefcase-medical', name: 'Complementary' },
        { icon: 'fa-baby', name: 'BirthInsurance' },
        { icon: 'fa-umbrella-beach', name: 'Travel' },
        { icon: 'fa-pencil-alt', name: 'Surety' },
        { icon: 'fa-credit-card', name: 'Credit' },
        { icon: 'fa-wallet', name: 'retirement' },
        { icon: 'fa-user-injured', name: 'Personal' },
        { icon: 'fa-user-md', name: 'Foreign' },
        { icon: 'fa-car', name: 'Secondhand' }
      ]
      const routeName = this.$route.name.toLowerCase()
      const filtered = categories.filter(
        c => routeName.indexOf(c.name.toLowerCase()) > -1
      )
      return filtered.length > 0 ? filtered[0].icon : null
    }
  }
}
</script>

<style></style>
